// Imports
import React from 'react';
import PageTitle from '../shared-components/page-title';
import LeadingText from '../shared-components/leading-text';


// Function component
const UnavailableFeature: React.FC = () => {
	// Return JSX
	return (
		<React.Fragment>
			<PageTitle appendCommunityName={false}>Requires upgraded plan</PageTitle>
			<LeadingText>This page is only available if your community upgrades its subscription plan.</LeadingText>
		</React.Fragment>
	);
};

export default UnavailableFeature;
